import { Box, styled } from '@mui/material';

import { calculateDimensions, calculateMargin } from './StackItem.utils';

import {
  StackTextStyle,
  StackItemTextBlockStyle,
  StackItemBorderContainerStyle,
} from './StackItem.types';

const stackItemTextBlockMargin = 10;

export const StackItemContainer = styled(Box)(() => ({
  width: '180px',
  height: '180px',
  display: 'flex',
}));

export const StackItemBorderContainer = styled('div')(
  ({ length, color, shadow }: StackItemBorderContainerStyle) => ({
    width: `${calculateDimensions(length)}px`,
    height: `${calculateDimensions(length)}px`,
    display: 'flex',

    borderRadius: '50%',
    border: `2px solid ${color}`,
    boxShadow: `15px 25px 15px 4px ${shadow}`,

    margin: `${calculateMargin()}px auto auto ${calculateMargin()}px`,
  }),
);

export const StackItemTextBlock = styled('div')(
  ({ bgColor }: StackItemTextBlockStyle) => ({
    width: `calc(100% - ${stackItemTextBlockMargin * 2}px)`,
    height: `calc(100% - ${stackItemTextBlockMargin * 2}px)`,
    display: 'flex',

    borderRadius: '50%',
    backgroundColor: bgColor,

    margin: `${stackItemTextBlockMargin}px`,
  }),
);

export const StackText = styled('div')(({ color, active }: StackTextStyle) => ({
  color: active ? 'white' : color,

  margin: 'auto',
}));
